
import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, createUrlTreeFromSnapshot, RouterStateSnapshot } from "@angular/router";
import { Store } from "@ngxs/store";
import { JwtHelperService } from "@auth0/angular-jwt";
import { OrderPortalGlobalState } from "../../../shared/state/order-portal-global.state";
import { Authorize } from "../../../models/authorize.model";
import { Login } from "../../../shared/state/order-portal-global.actions";
export const authGuard = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const store = inject(Store);
  const jwtHelper = new JwtHelperService();
  const authorize = store.selectSnapshot(OrderPortalGlobalState.Authorize);
  const isAuthenticated = authorize && !jwtHelper.isTokenExpired(authorize.jwtToken);
  if (isAuthenticated) {
    return true;
  }
 store.dispatch(new Login(undefined));
  return createUrlTreeFromSnapshot(next, ["/", "accounts", "login"]);
};
